<template>
  <v-app-bar
    dense
    flat
    outlined
    height="50"
  >
    <v-row
      no-gutters
    >
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="template_style"
          color="primary"
          class="elevation-0"
          @click="editStyle()"
        >
          <v-icon>mdi-palette-swatch</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="template_setting"
          color="primary"
          class="elevation-0"
          @click="editSettings"
        >
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="add_line"
          class="elevation-0"
          color="primary"
          @click="addLine()"
        >
          <v-icon left>
            mdi-plus-circle-outline
          </v-icon> Line
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="reload_template"
          color="primary"
          class="elevation-0"
          :disabled="!dirty"
          @click="reload"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="default_template"
          color="primary"
          class="elevation-0"
          @click="fetchDefaultTemplate()"
        >
          <v-icon>mdi-download-network</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="info_template"
          color="primary"
          class="elevation-0"
          @click="help()"
        >
          <v-icon>mdi-help-box</v-icon>
        </v-btn>
      </v-col>
      <v-col
        cols="auto"
        class="pr-2"
      >
        <v-btn
          id="info_template"
          color="danger"
          class="elevation-0"
          @click="deleteTemplate()"
        >
          <v-icon color="white">
            mdi-delete
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          id="save_template"
          class="elevation-0"
          color="success"
          :disabled="!dirty"
          @click="updateTemplate()"
        >
          <v-icon left>
            mdi-check
          </v-icon> Save
        </v-btn>
      </v-col>
    </v-row>
    <template-helper :show.sync="showHelp" />
  </v-app-bar>
</template>

<script>
import TemplateHelper from "./templateHelper/TemplateHelper.vue";

export default {
  name: "TemplateOptions",
  components: {
    TemplateHelper
  },
  props: {
    dirty: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showHelp: false
    };
  },
  methods: {
    reload() {
      this.$emit("reload");
    },
    editStyle() {
        this.$emit("editStyle");
    },
    editSettings() {
        this.$emit("editSettings");
    },
    addLine() {
      this.$emit("addLine");
    },
    updateTemplate() {
      this.$emit("update");
    },
    fetchDefaultTemplate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure want to load default template settings ?")
        .then((confirm) => {
          if (confirm) {
            this.$emit("fetchDefault");
          }
        });
    },
    deleteTemplate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure want to delete settings ?")
        .then((confirm) => {
          if (confirm) {
            this.$emit("deleteTemplate");
          }
        });
    },
    help() {
      this.showHelp = true;
    }
  }
};
</script>